/*
  Trappbutiken – konfiguratorernas stegflöde (Wubs, Liam 2026-09-13).
  DELAS av ledstång, tröskel och hyllplan. Allt hänger på markup de tre redan har gemensamt:
    .wubs-stairs              roten
    .wubs-step[data-step]     stegen – motorerna togglar .is-active
    [data-next]               stegets nästa-knapp
    [data-add-to-cart] / [data-ws-atc] / [data-ws-mobile-atc]   köpknapparna

  Tre saker, alla styrda av vilket steg som är aktivt:

  1. NYTT STEG → TILL TOPPEN ("konfigurator, nytt steg, skrollas längst upp").
     Desktop (app-läget): panelen scrollar, inte sidan – den skrollas till 0.
     Mobil: sidan scrollar – panelens topp läggs under headern, men BARA om den ligger ovanför
     fönstret. Står kunden högre upp (vid 3D-vyn och stegraden) flyttas inget.
     ⚠️ Motorernas egna window.scrollTo vid stegbyte är borttagna i sektionerna – i app-läget
     gjorde de ingenting, och på mobil hade två mjuka scrollningar tävlat.

  2. "NÄSTA STEG" I STÄLLET FÖR KÖPKNAPP FRAM TILL SISTA STEGET ("Lägg i varukorg ska vara Nästa
     steg, fram tills sista steget, där blir det ATC"). Gäller köpknapparna UTANFÖR stegen
     (sammanfattningen, prisraden, mobilraden).
     ⚠️ Knappen byts inte – en EGEN nästa-knapp läggs bredvid och roten får .is-sista-steg.
     Motorerna fortsätter styra köpknappen (disabled, "Lägger i varukorgen…") precis som förut;
     hade samma knapp fått två ägare hade de skrivit över varandra.
     Nästa-knappen speglar det aktiva stegets [data-next] (disabled) och klickar på den – all
     validering ligger kvar i motorn.

  3. TIPS PER STEG i en sidopanel (snippets/wubs-konfig-tips.liquid har datan och markupen).
     Knappen flyttas in i det aktiva stegets rubrikkort och bär tipsets rubrik. Steg utan egna
     tips får steg 0 ("alla steg"); finns inget alls döljs knappen.
*/
(function () {
  var root = document.querySelector('.wubs-stairs');
  if (!root) return;
  var steg = [].slice.call(root.querySelectorAll('.wubs-step[data-step]'));
  if (!steg.length) return;

  function nr(el) { return el ? parseInt(el.getAttribute('data-step'), 10) || 0 : 0; }
  var sista = steg.reduce(function (m, s) { return Math.max(m, nr(s)); }, 0);
  function aktivt() { return root.querySelector('.wubs-step.is-active[data-step]'); }

  /* ------------------------------------------------------------ 1. till toppen */
  function tillToppen() {
    var panel = root.querySelector('.wubs-panel');
    if (panel && panel.scrollHeight > panel.clientHeight + 1 && /(auto|scroll)/.test(getComputedStyle(panel).overflowY)) {
      /* Målet är det AKTIVA STEGETS topp, inte panelens (Liam 2026-09-17: "när man klickar nästa
         steg ska man hamna såhär i skrollen" – bilden visar stegrubriken direkt under prisraden).
         Panelens topp duger inte: ledstången och tröskeln inleder med sidintrot ("Måttbeställ dina
         nya ledstänger", 79 px) som annars låg kvar överst på VARJE steg. Hyllplanet saknar intro
         och hamnar på 0 ändå, så beteendet blir detsamma i alla tre.
         Vid första renderingen körs inte tillToppen alls, så intron syns när kunden landar. */
      var el = aktivt();
      var mal = 0;
      if (el) {
        mal = panel.scrollTop + el.getBoundingClientRect().top - panel.getBoundingClientRect().top;
        mal = Math.max(0, Math.min(Math.round(mal), panel.scrollHeight - panel.clientHeight));
      }
      if (panel.scrollTop !== mal) {
        /* ⚠️⚠️ SMOOTH-SCROLL PÅ EN EGEN SCROLLCONTAINER KAN SVÄLJAS TYST. Uppmätt på mobilen
           2026-09-17: panel.scrollTop 600 → 600 en hel sekund efter scrollTo({behavior:'smooth'}),
           medan `panel.scrollTop = 0` flyttade direkt. Före det mobila appläget var panelen ingen
           scrollcontainer på mobil, så felet fanns inte att hitta.
           Hårt fallback om ingenting rört sig: har smooth verkligen startat är scrollTop ett annat
           tal efter 350 ms, och då rörs den inte. */
        var fran = panel.scrollTop;
        try { panel.scrollTo({ top: mal, behavior: 'smooth' }); } catch (e) { panel.scrollTop = mal; }
        setTimeout(function () { if (panel.scrollTop === fran) panel.scrollTop = mal; }, 350);
      }
      return;
    }
    var mal = panel || root;
    var hdr = document.querySelector('.wubs-header-section') || document.querySelector('wubs-header');
    var under = hdr ? Math.max(0, hdr.getBoundingClientRect().bottom) : 0;
    var topp = mal.getBoundingClientRect().top;
    if (topp >= under) return;
    window.scrollTo({ top: Math.max(0, window.scrollY + topp - under), behavior: 'smooth' });
  }

  /* Visa ett element i stegets scroll (2026-09-18, Liam om hyllplanets hörnsteg: "när man valt här,
     skrollas ned till vilka hörn"). Scrollar BARA om elementet inte redan syns helt, och lägger dess
     topp överst i panelen (appläget) eller under headern (där sidan scrollar). Samma hårda fallback
     som tillToppen – smooth-scroll på en egen scrollcontainer kan sväljas tyst. */
  function visa(el) {
    if (!el) return;
    var luft = 12;
    var panel = root.querySelector('.wubs-panel');
    if (panel && panel.scrollHeight > panel.clientHeight + 1 && /(auto|scroll)/.test(getComputedStyle(panel).overflowY)) {
      var pr = panel.getBoundingClientRect(), er = el.getBoundingClientRect();
      if (er.top >= pr.top && er.bottom <= pr.bottom) return;
      var mal = panel.scrollTop + er.top - pr.top - luft;
      mal = Math.max(0, Math.min(Math.round(mal), panel.scrollHeight - panel.clientHeight));
      if (panel.scrollTop === mal) return;
      var fran = panel.scrollTop;
      try { panel.scrollTo({ top: mal, behavior: 'smooth' }); } catch (e) { panel.scrollTop = mal; }
      setTimeout(function () { if (panel.scrollTop === fran) panel.scrollTop = mal; }, 350);
      return;
    }
    var hdr = document.querySelector('.wubs-header-section') || document.querySelector('wubs-header');
    var under = hdr ? Math.max(0, hdr.getBoundingClientRect().bottom) : 0;
    var r = el.getBoundingClientRect();
    if (r.top >= under && r.bottom <= window.innerHeight) return;
    var y = Math.max(0, window.scrollY + r.top - under - luft), y0 = window.scrollY;
    try { window.scrollTo({ top: y, behavior: 'smooth' }); } catch (e) { window.scrollTo(0, y); }
    setTimeout(function () { if (window.scrollY === y0) window.scrollTo(0, y); }, 350);
  }

  /* ------------------------------------------------------- 2. nästa steg-knappar */
  var nastaText = root.getAttribute('data-konfig-nasta-text') || 'Nästa steg';
  var nastaKnappar = [];
  [].slice.call(root.querySelectorAll('[data-add-to-cart], [data-ws-atc], [data-ws-mobile-atc]')).forEach(function (atc) {
    if (atc.closest('.wubs-step')) return;
    atc.setAttribute('data-konfig-bar-atc', '');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = atc.className;
    b.setAttribute('data-konfig-nasta', '');
    b.textContent = nastaText;
    b.addEventListener('click', function () {
      var nx = aktivt() && aktivt().querySelector('[data-next]');
      if (nx && !nx.disabled) nx.click();
    });
    atc.parentNode.insertBefore(b, atc);
    nastaKnappar.push(b);
  });

  /* Barens knapp säger VART den leder – samma text som stegets egen nästa-knapp ("4. Välj ändar →"),
     inte ett generiskt "Nästa steg" (Liam 2026-10-29). Stegets knapp döljs på mobil (CSS), så baren är
     den enda vägen framåt där. Faller tillbaka på inställningens text om knappen saknar egen. */
  function nastaEtikett(nx) {
    /* Byggs ur NÄSTA stegs rubrik ("3. Mått och antal →") – tröskelns och hyllplanets egna knappar
       säger bara "Nästa", ledstångens råkar redan säga samma sak. Saknas rubriken: knappens text. */
    var n = nr(aktivt()) + 1;
    var nasta = root.querySelector('.wubs-step[data-step="' + n + '"]');
    var rubrik = nasta && nasta.querySelector('.wubs-step-title, h2, h3');
    var namn = rubrik ? (rubrik.textContent || '').replace(/\s+/g, ' ').trim() : '';
    if (namn) return n + '. ' + namn + ' \u2192';
    var t = nx ? (nx.textContent || '').replace(/\s+/g, ' ').trim() : '';
    return t || nastaText;
  }
  /* Stegraden i baren ersätter stegchipsen på mobil (Liam 2026-10-29: chipsen tog 40 px av 3D-vyn
     och upprepade knapparna): "Steg 3 av 6 · Ange längder". Byggs en gång, uppdateras vid varje
     stegbyte. På desktop är baren dold, så raden syns bara i det mobila appläget. */
  var barSteg = null;
  function stegrad() {
    var bar = root.querySelector('[data-mobile-bar], [data-ws-mobile-bar]');
    if (!bar) return;
    if (!barSteg) {
      barSteg = document.createElement('p');
      barSteg.className = 'wubs-barsteg';
      barSteg.setAttribute('aria-live', 'polite');
      bar.insertBefore(barSteg, bar.firstChild);
    }
    var el = aktivt();
    var rubrik = el && el.querySelector('.wubs-step-title, h2, h3');
    var namn = rubrik ? (rubrik.textContent || '').replace(/\s+/g, ' ').trim() : '';
    barSteg.textContent = 'Steg ' + nr(el) + ' av ' + sista + (namn ? ' · ' + namn : '');
  }

  function speglaNasta() {
    var el = aktivt();
    var nx = el && el.querySelector('[data-next]');
    var ar = nr(el) >= sista || !nx;
    root.classList.toggle('is-sista-steg', ar);
    nastaKnappar.forEach(function (b) {
      var var_av = b.disabled;
      b.disabled = !nx || nx.disabled;
      var t = nastaEtikett(nx);
      if (b.textContent !== t) b.textContent = t;
      /* GUIDNING (Liam 2026-10-29: "Vi måste lixom guida användaren genom upplevelsen mer"): knappen
         pulserar en gång när den blir klickbar – kunden ser vart nästa tryck ska. Bara i mobilläget. */
      if (var_av && !b.disabled && document.documentElement.classList.contains('wubs-appmode-m')) {
        b.classList.remove('is-puls'); void b.offsetWidth; b.classList.add('is-puls');
        setTimeout(function () { b.classList.remove('is-puls'); }, 1400);
      }
    });
    stegrad();
  }

  /* ⛔ AUTOMATISKT NÄSTA STEG BORTTAGET 2026-10-29 (Liam: "ta bort automatiskt nästa steg i live").
     Fanns samma kväll: ett val på mobil gick vidare efter 550 ms. Kunden går nu vidare med barens knapp,
     som pulserar när den blir klickbar (speglaNasta ovan). Se docs/konfig-gemensamt.md, GUIDNING. */

  /* ------------------------------------------------------------- 3. tips per steg */
  var tips = {};
  try { tips = JSON.parse((root.querySelector('[data-konfig-tips]') || {}).textContent || '{}'); } catch (e) { tips = {}; }
  var knapp = root.querySelector('[data-konfig-tipsknapp]');
  var drawer = root.querySelector('[data-konfig-tipsdrawer]');
  var oppen = false;

  function tipsFor(n) { return tips[String(n)] || tips['0'] || null; }
  function stegTitel(el) {
    var t = el && el.querySelector('.wubs-step-title');
    return t ? t.textContent.trim() : '';
  }

  function placeraKnapp() {
    if (!knapp) return;
    var el = aktivt();
    var tip = el && tipsFor(nr(el));
    knapp.hidden = !tip;
    if (!tip) return;
    knapp.querySelector('[data-konfig-tipsknapp-rubrik]').textContent = tip.rubrik || stegTitel(el);
    /* LITEN TIPSKNAPP TILL HÖGER OM RUBRIKEN (Liam 2026-10-29: "Tips och trix kanske man kan göra till en
       mindre Tips knapp och lägga till höger i höjd med titeln?"). Ersätter samma dags "under valen".
       Rubrikkortet blir ett rutnät (.har-tips): rubrik | knapp, brödtexten under i full bredd. Tipsets
       rubrik visas i panelen som öppnas; i knappen står bara "Tips". */
    /* ⚠️ INTE i rubrikkortet: ledstångens injectTokens() skriver om .wubs-headcard (innerHTML ur data-orig)
       vid varje uppdatering – knappen försvann, stegets höjd ändrades och autonästa avbröts. Knappen är
       stegets FÖRSTA barn och läggs i rubrikens höjd med CSS (.wubs-step.har-tips). */
    /* 🧨 Rör klassen BARA om den ändras: stegets class-attribut bevakas av observatören nedan (stegbyte),
       och även en "tom" classList.add skapar en mutation → vidStegbyte → placeraKnapp → … oändlig loop
       som låste sidan (uppmätt 2026-10-29, bara i arbetstemat). */
    if (el.firstElementChild !== knapp) el.insertBefore(knapp, el.firstChild);
    [].forEach.call(root.querySelectorAll('.wubs-step.har-tips'), function (s2) { if (s2 !== el) s2.classList.remove('har-tips'); });
    if (!el.classList.contains('har-tips')) el.classList.add('har-tips');
    if (!knapp.classList.contains('is-kompakt')) knapp.classList.add('is-kompakt');
    if (oppen) fyllDrawer();
  }

  function fyllDrawer() {
    var el = aktivt();
    var n = nr(el);
    var tip = tipsFor(n);
    if (!tip || !drawer) return;
    var etikett = knapp ? knapp.querySelector('.wubs-tipsknapp__etikett').textContent : 'Tips';
    drawer.querySelector('[data-konfig-tips-steg]').textContent =
      etikett + ' · Steg ' + n + (stegTitel(el) ? ' – ' + stegTitel(el) : '');
    drawer.querySelector('[data-konfig-tips-rubrik]').textContent = tip.rubrik || stegTitel(el);
    drawer.querySelector('[data-konfig-tips-text]').innerHTML = tip.html || '';
    var lank = drawer.querySelector('[data-konfig-tips-lank]');
    // Bara riktiga länkar: relativa sökvägar eller http(s). Inget javascript: från ett textfält.
    var ok = tip.lank_text && tip.lank_url && /^(\/|https?:\/\/)/i.test(tip.lank_url);
    lank.hidden = !ok;
    if (ok) {
      lank.setAttribute('href', tip.lank_url);
      lank.querySelector('[data-konfig-tips-lank-text]').textContent = tip.lank_text;
    }
  }

  var stangTimer = null;
  function oppna() {
    if (!drawer || oppen) return;
    fyllDrawer();
    clearTimeout(stangTimer);
    drawer.hidden = false;
    void drawer.offsetWidth; // tvinga fram startläget innan övergången (rAF stryps i förhandsgranskningen)
    drawer.classList.add('is-open');
    oppen = true;
    if (window.WubsScroll) window.WubsScroll.las();
    var stang = drawer.querySelector('.wubs-tipsdrawer__stang');
    if (stang) stang.focus();
  }
  function stang() {
    if (!drawer || !oppen) return;
    drawer.classList.remove('is-open');
    oppen = false;
    if (window.WubsScroll) window.WubsScroll.slapp();
    stangTimer = setTimeout(function () { drawer.hidden = true; }, 320);
    if (knapp && !knapp.hidden) knapp.focus();
  }

  if (knapp) knapp.addEventListener('click', oppna);
  if (drawer) {
    drawer.addEventListener('click', function (e) { if (e.target.closest('[data-konfig-tips-stang]')) stang(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && oppen) stang(); });
  }

  /* --------------------------------------------------------------- stegbyte */
  var forra = nr(aktivt());
  function vidStegbyte(forsta) {
    var n = nr(aktivt());
    // CSS-krok: sidintrot visas bara i steg 1 på mobil (wubs-konfig.css, guidningen 2026-10-29).
    if (n) root.setAttribute('data-aktivt-steg', String(n));
    speglaNasta();
    placeraKnapp();
    if (!forsta && n && n !== forra) tillToppen();
    forra = n;
  }

  new MutationObserver(function (lista) {
    var klass = false, knappar = false;
    lista.forEach(function (m) {
      if (m.attributeName === 'class' && m.target.classList && m.target.classList.contains('wubs-step')) klass = true;
      if (m.attributeName === 'disabled' && m.target.hasAttribute && m.target.hasAttribute('data-next')) knappar = true;
    });
    if (klass) vidStegbyte(false);
    else if (knappar) speglaNasta();
  }).observe(root, { subtree: true, attributes: true, attributeFilter: ['class', 'disabled'] });

  vidStegbyte(true);

  /* ------------------------------------- EGEN NCS SIST + FRAM TILL KODFÄLTET (2026-10-29)
     Liam: "egen ncs vill jag ska ligga sist, när man valt den, skrollas man ned till input?"
     · Kortet "… egen NCS …" flyttas sist i sitt rutnät. Motorerna bygger om korten (innerHTML) vid
       varje val, därför en observatör och inte en engångsflytt. Ofarligt: alla tre känner igen
       korten på data-attribut (data-fin / data-finish), aldrig på ordning.
     · När NCS-fältet ([data-ncs-wrap]) blir synligt scrollas det fram och får fokus – annars låg det
       under kortraden, utanför skärmen på mobil, och nästa-knappen var låst utan synlig orsak. */
  var NCS_RE = /egen\s+NCS/i;
  function ncsSist() {
    [].forEach.call(root.querySelectorAll('.wubs-optgrid'), function (g) {
      var barn = [].slice.call(g.children);
      var kort = barn.filter(function (c) { return NCS_RE.test(c.textContent || ''); });
      if (!kort.length) return;
      /* Flytta bara om NCS-korten INTE redan är de sista (i sin ordning) – annars hade två NCS-kort i samma
         rutnät bytt plats med varandra vid varje mutation, i all oändlighet. */
      var svans = barn.slice(barn.length - kort.length);
      var redanSist = svans.every(function (c, i) { return c === kort[i]; });
      if (!redanSist) kort.forEach(function (c) { g.appendChild(c); });
    });
  }
  ncsSist();
  new MutationObserver(function (lista) {
    var kort = false, ncs = null;
    lista.forEach(function (m) {
      if (m.type === 'childList') kort = true;
      if (m.type === 'attributes' && m.target.hasAttribute('data-ncs-wrap') && !m.target.hidden) ncs = m.target;
    });
    if (kort) ncsSist();
    if (ncs) setTimeout(function () {
      if (ncs.hidden || !ncs.offsetParent) return;
      visa(ncs);
      var f = ncs.querySelector('[data-ncs-input]');
      if (f && !f.value) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
    }, 120);
  }).observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['hidden'] });

  /* ------------------------------------------------- 4. mobilt appläge (2026-09-17)
     Liam: "konfiguratorerna mobilanpassning … Sticky nedre del", referens
     wernamodesign.se/configurator. Sidscrollen låses under 992 px och panelen blir egen
     scrollcontainer – CSS:en ligger sist i wubs-konfig.css.

     ⚠️ Klassen sätts HÄRIFRÅN och inte i wubs-konfig-ui.js, för hyllplanet laddar inte den
     filen. Stegskriptet laddas av alla tre konfiguratorerna.
     ⚠️ Desktopens .wubs-appmode (≥992) och den här (.wubs-appmode-m, <992) utesluter varandra
     via sina mediefrågor – båda kan stå på <html> samtidigt utan att krocka.
     ⚠️ Höjderna MÄTS, de gissas inte: headern är 104 px på mobil i dag men bär en annonsrad
     som kan slås av, och barens höjd beror på knapptexten. */
  function matt() {
    var hdr = document.querySelector('.shopify-section-group-header-group');
    var hh = hdr ? Math.round(hdr.getBoundingClientRect().height) : 0;
    if (hh) document.documentElement.style.setProperty('--k-header-h', hh + 'px');
    var bar = root.querySelector('[data-mobile-bar], [data-ws-mobile-bar]');
    var bh = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
    if (bh) document.documentElement.style.setProperty('--k-bottom-h', bh + 'px');
  }
  function lage() {
    var mobil = window.matchMedia('(max-width: 991px)').matches;
    document.documentElement.classList.toggle('wubs-appmode-m', mobil);
    // Baren har ingen höjd förrän CSS:en visat den – mät i nästa tick, inte i samma.
    if (mobil) setTimeout(matt, 0);
  }

  /* Baren MELLAN 3D-vyn och den scrollande listan (Liam 2026-09-17: "sticky delen, hade de lagt
     mellan 3d och själva skrollande menyn, gillade det"). I markupen ligger den som SYSKON till
     .wubs-container, efter den – alltså sist. Flytten görs i DOM:en i stället för med CSS `order`,
     för visual och panel bor inne i containern och hade krävt `display: contents` på den för att
     hamna i samma flexflöde. Flytten är ofarlig på desktop: där är baren dold ändå.
     ⚠️ Motorerna håller en referens till ELEMENTET (els.mobileBar) och skriver bara i det – de
     bryr sig inte om var det sitter. */
  (function flyttaBar() {
    var bar = root.querySelector('[data-mobile-bar], [data-ws-mobile-bar]');
    var behallare = root.querySelector('.wubs-container');
    var panel = root.querySelector('.wubs-panel');
    if (!bar || !behallare || !panel) return;
    /* 2026-10-29: baren flyttad NED, efter listan (Liam "Borde den baren ligga nere istället för
       mitten?" – ja: tummens räckvidd, och där kunden letar efter "Lägg i varukorg"). Listan ligger
       nu direkt under 3D-vyn. Flytten i DOM:en behålls – i markupen ligger baren UTANFÖR containern. */
    if (bar.parentNode === behallare && bar.previousElementSibling === panel) return;
    behallare.appendChild(bar);
  })();
  /* ---------------------------------------------- 5. numpad på måttfälten (2026-09-17)
     Liam: "när man klickar in i dessa inputs, kan vi se till att vi visar numpad som input och
     inte vanligt tagnetbord?". Alla måttfält är `type="number"` med `step="1"`, alltså heltal –
     `inputmode="numeric"` ger den rena sifferknappsatsen. `decimal` vore fel: det ger en
     decimalavskiljare som fälten ändå avvisar.
     ⚠️ Attributet SÄTTS I FÖRVÄG, inte vid fokus. iOS läser inputmode när fältet får fokus, så
     en focusin-lyssnare hade hunnit för sent till första tangentbordet.
     ⚠️ Hyllplanets rader byggs i JS när kunden lägger till hyllplan, därför observatorn –
     en engångskörning hade missat varje ny rad.
     ⚠️ NCS-fältet är type="text" och rörs inte; det ska ha bokstäver. */
  function numpad(inom) {
    [].slice.call((inom || root).querySelectorAll('input[type="number"]:not([inputmode])'))
      .forEach(function (i) { i.setAttribute('inputmode', 'numeric'); });
  }
  numpad();

  /* Ettans optiska centrering – se kommentaren vid .num.is-etta i wubs-konfig.css.
     CSS kan inte välja på textinnehåll, och siffran är den enda glyfen med skev bärning. */
  function etta(inom) {
    [].slice.call((inom || root).querySelectorAll('.stepper-btn .num')).forEach(function (n) {
      n.classList.toggle('is-etta', (n.textContent || '').trim() === '1');
    });
  }
  etta();

  /* ---------------------------------------- 7. EGNA RULLISTOR (2026-09-18, Liam "egna dropdowns tack")
     Webbläsarens egen lista (mörk macOS-popup, uppe i hörnet över 3D-vyn) ersätts av en i husets
     stil. ⚠️ Den riktiga <select> ÄR KVAR och är sanningskällan: den flyttas in i komponenten,
     döljs, och ett val sätter dess värde och skickar `input` + `change` (bubblar) – alla
     konfiguratorernas lyssnare (direkt på elementet eller delegerade på roten) fungerar orörda.
     ⚠️ Motorerna BYGGER OM korten (innerHTML) vid ändringar; observatören nedan klär då den nya
     rullistan. Ingen motor sätter select.value programmatiskt (kontrollerat) – texten synkas vid
     `change`, när listan öppnas och när alternativen byts.
     ⚠️ Knappen läggs FÖRST i komponenten: i hyllplanets och tröskelns <label>-omslag blir den då
     etikettens kontroll, så ett klick på "Modell" öppnar listan. Ledstångens label[for] pekas om. */
  var ddNr = 0;
  var PIL = '<svg class="wubs-dd__pil" viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false"><path d="M4 6l4 4 4-4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var BOCK = '<svg class="wubs-dd__bock" viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false"><path d="M3.5 8.5l3 3 6-7" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function ddText(o) { return o ? (o.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function ddSignatur(sel) {
    return JSON.stringify([].slice.call(sel.options).map(function (o) { return [o.value, ddText(o), !!o.disabled]; }));
  }
  function ddEsc(t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }

  function ddBygg(sel) {
    ddNr++;
    var id = 'wubs-dd-' + ddNr;
    var dd = document.createElement('div');
    dd.className = 'wubs-dd';
    dd.innerHTML =
      '<button type="button" class="wubs-dd__knapp" id="' + id + '-k" aria-haspopup="listbox" aria-expanded="false">' +
        '<span class="wubs-dd__text" id="' + id + '-t"></span>' + PIL + '</button>' +
      '<ul class="wubs-dd__lista" id="' + id + '-l" role="listbox" tabindex="-1" hidden></ul>';
    sel.parentNode.insertBefore(dd, sel);
    dd.appendChild(sel);
    sel.classList.add('wubs-dd__native');
    sel.setAttribute('tabindex', '-1');
    sel.setAttribute('aria-hidden', 'true');
    sel.setAttribute('data-wubs-dd', '');

    var knapp = dd.querySelector('.wubs-dd__knapp');
    var lista = dd.querySelector('.wubs-dd__lista');
    var aktiv = -1, sok = '', sokTimer = null;
    /* Knappen får SAMMA fyllning som listan den ersätter: vit på de gråa korten (ledstång, hyllplan)
       men grå i tröskelns ljusa kort – annars syntes ingen fältkant där alls. */
    var fyll = getComputedStyle(sel).backgroundColor;
    if (fyll && fyll !== 'transparent' && !/^rgba\(0, 0, 0, 0\)$/.test(fyll)) knapp.style.backgroundColor = fyll;

    /* Etiketten: omslutande <label> (hyllplan, tröskel) eller label[for] (ledstången). */
    var etikett = sel.id ? root.querySelector('label[for="' + sel.id + '"]') : null;
    if (etikett) etikett.htmlFor = knapp.id;
    var omslag = dd.closest('label');
    var etikettText = etikett || (omslag && omslag.querySelector('.wubs-mini-label'));
    if (etikettText) {
      if (!etikettText.id) etikettText.id = id + '-e';
      knapp.setAttribute('aria-labelledby', etikettText.id + ' ' + id + '-t');
      lista.setAttribute('aria-labelledby', etikettText.id);
    }

    function poster() { return [].slice.call(lista.querySelectorAll('[role="option"]')); }
    function byggLista() {
      lista.innerHTML = [].slice.call(sel.options).map(function (o, i) {
        return '<li class="wubs-dd__val" role="option" id="' + id + '-o' + i + '" data-i="' + i + '"' +
          (o.disabled ? ' aria-disabled="true"' : '') + ' aria-selected="false">' +
          '<span class="wubs-dd__valtext">' + ddEsc(ddText(o)) + '</span>' + BOCK + '</li>';
      }).join('');
      dd.__sig = ddSignatur(sel);
    }
    function synka() {
      if (dd.__sig !== ddSignatur(sel)) byggLista();
      var o = sel.options[sel.selectedIndex];
      dd.querySelector('.wubs-dd__text').textContent = ddText(o) || '–';
      poster().forEach(function (li, i) { li.setAttribute('aria-selected', i === sel.selectedIndex ? 'true' : 'false'); });
      knapp.disabled = !!sel.disabled;
    }
    function markera(i) {
      var p = poster();
      if (!p.length) return;
      i = Math.max(0, Math.min(p.length - 1, i));
      aktiv = i;
      p.forEach(function (li, j) { li.classList.toggle('is-aktiv', j === i); });
      lista.setAttribute('aria-activedescendant', p[i].id);
      var li = p[i];
      if (li.offsetTop < lista.scrollTop) lista.scrollTop = li.offsetTop;
      else if (li.offsetTop + li.offsetHeight > lista.scrollTop + lista.clientHeight) lista.scrollTop = li.offsetTop + li.offsetHeight - lista.clientHeight;
    }
    function nasta(fran, steg) {
      var p = poster(), i = fran;
      for (var n = 0; n < p.length; n++) {
        i += steg;
        if (i < 0 || i >= p.length) return fran;
        if (p[i].getAttribute('aria-disabled') !== 'true') return i;
      }
      return fran;
    }
    function oppnaDd() {
      if (knapp.disabled || !lista.hidden) return;
      synka();
      [].slice.call(root.querySelectorAll('.wubs-dd.is-open')).forEach(function (a) { if (a !== dd && a.__stang) a.__stang(false); });
      dd.classList.add('is-open');
      dd.classList.remove('is-upp');
      /* Listan får bli lika bred som kortet den står i (ut över "Antal"), inte bara knappen –
         annars bröts alternativen på tre rader i den 233 px smala kolumnen (375 px, 2026-09-18). */
      var kort = dd.closest('.wubs-card, .wubs-tr-card, .wubs-step') || root;
      var k0 = knapp.getBoundingClientRect();
      lista.style.maxWidth = Math.max(k0.width, Math.floor(kort.getBoundingClientRect().right - k0.left - 12)) + 'px';
      lista.hidden = false;
      knapp.setAttribute('aria-expanded', 'true');
      /* Får listan inte plats nedåt i panelen/fönstret men uppåt – vänd den. Annars: scrolla fram den. */
      var panel = root.querySelector('.wubs-panel');
      var rullar = panel && panel.scrollHeight > panel.clientHeight + 1 && /(auto|scroll)/.test(getComputedStyle(panel).overflowY);
      var ram = rullar ? panel.getBoundingClientRect() : { top: 0, bottom: window.innerHeight };
      var kr = knapp.getBoundingClientRect(), lh = lista.offsetHeight + 6;
      var saknas = Math.ceil(kr.bottom + lh - ram.bottom + 12);
      if (saknas > 12 && kr.top - lh >= ram.top) dd.classList.add('is-upp');
      else if (saknas > 12) { if (rullar) panel.scrollTop += saknas; else window.scrollBy(0, saknas); }
      markera(sel.selectedIndex > -1 ? sel.selectedIndex : 0);
      lista.focus({ preventScroll: true });
    }
    function stangDd(fokus) {
      if (lista.hidden) return;
      lista.hidden = true;
      dd.classList.remove('is-open', 'is-upp');
      knapp.setAttribute('aria-expanded', 'false');
      lista.removeAttribute('aria-activedescendant');
      if (fokus !== false) knapp.focus({ preventScroll: true });
    }
    dd.__stang = stangDd;
    function valj(i) {
      var o = sel.options[i];
      if (!o || o.disabled) return;
      var byte = sel.selectedIndex !== i;
      /* Motorn kan bygga om kortet i change-hanteraren – då försvinner den här komponenten.
         Kom ihåg VILKEN rullista det var (dess data-attribut) och ge den nya fokus efteråt. */
      var nyckel = [].slice.call(sel.attributes).filter(function (a) { return /^data-/.test(a.name) && a.name !== 'data-wubs-dd'; })
        .map(function (a) { return '[' + a.name + '="' + a.value.replace(/"/g, '\\"') + '"]'; }).join('');
      stangDd(true);
      if (!byte) return;
      sel.selectedIndex = i;
      sel.dispatchEvent(new Event('input', { bubbles: true }));
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      synka();
      if (!dd.isConnected && nyckel) setTimeout(function () {
        var ny = root.querySelector('select' + nyckel);
        var ndd = ny && ny.closest('.wubs-dd');
        var k = ndd && ndd.querySelector('.wubs-dd__knapp');
        if (k) k.focus({ preventScroll: true });
      }, 120);
    }

    knapp.addEventListener('click', function () { if (lista.hidden) oppnaDd(); else stangDd(); });
    knapp.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'Enter' || e.key === ' ') { e.preventDefault(); oppnaDd(); }
    });
    lista.addEventListener('keydown', function (e) {
      var p = poster();
      if (e.key === 'ArrowDown') { e.preventDefault(); markera(nasta(aktiv, 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); markera(nasta(aktiv, -1)); }
      else if (e.key === 'Home') { e.preventDefault(); markera(nasta(-1, 1)); }
      else if (e.key === 'End') { e.preventDefault(); markera(nasta(p.length, -1)); }
      else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); valj(aktiv); }
      else if (e.key === 'Escape') { e.preventDefault(); stangDd(); }
      else if (e.key === 'Tab') { stangDd(false); }
      else if (e.key.length === 1 && /\S/.test(e.key)) {
        /* Skriv för att hoppa – som i webbläsarens egen lista. */
        clearTimeout(sokTimer); sok += e.key.toLowerCase();
        sokTimer = setTimeout(function () { sok = ''; }, 600);
        for (var n = 1; n <= p.length; n++) {
          var j = (aktiv + n) % p.length;
          if (ddText(p[j]).toLowerCase().indexOf(sok) === 0 && p[j].getAttribute('aria-disabled') !== 'true') { markera(j); break; }
        }
      }
    });
    lista.addEventListener('click', function (e) {
      /* ⚠️ Listan ligger i hyllplanets/tröskelns <label>. Utan preventDefault "klickar" etiketten
         sin kontroll – knappen – efteråt, och listan öppnas igen direkt efter valet. */
      e.preventDefault();
      var li = e.target.closest('[role="option"]');
      if (li) valj(parseInt(li.getAttribute('data-i'), 10));
    });
    lista.addEventListener('mousemove', function (e) {
      var li = e.target.closest('[role="option"]');
      if (li && li.getAttribute('aria-disabled') !== 'true') markera(parseInt(li.getAttribute('data-i'), 10));
    });
    dd.addEventListener('focusout', function (e) {
      if (!dd.contains(e.relatedTarget)) stangDd(false);
    });
    /* Fokus som hamnar på den dolda rullistan (etikettklick, programmatiskt) går till knappen. */
    sel.addEventListener('focus', function () { knapp.focus({ preventScroll: true }); });
    sel.addEventListener('change', synka);
    dd.__synka = synka;
    byggLista();
    synka();
  }

  function rullistor() {
    [].slice.call(root.querySelectorAll('select:not([data-wubs-dd])')).forEach(function (sel) {
      if (sel.multiple || sel.size > 1) return;                 // bara vanliga enradslistor
      try { ddBygg(sel); } catch (e) { /* hellre webbläsarens lista än ingen alls */ }
    });
    [].slice.call(root.querySelectorAll('.wubs-dd')).forEach(function (dd) { if (dd.__synka) dd.__synka(); });
  }
  rullistor();
  document.addEventListener('pointerdown', function (e) {
    [].slice.call(root.querySelectorAll('.wubs-dd.is-open')).forEach(function (dd) {
      if (!dd.contains(e.target) && dd.__stang) dd.__stang(false);
    });
  }, true);

  var numpadTimer = null;
  new MutationObserver(function () {
    clearTimeout(numpadTimer);
    numpadTimer = setTimeout(function () { numpad(); etta(); rullistor(); }, 50);
  }).observe(root, { childList: true, subtree: true });

  /* ---------------------------------------- 6. "Läs mer" i sidintrot (2026-09-17)
     Liam: "i denna på mobil, gör Läs mer efter första meningen i brödtexten tack". Intron är
     169 px av en 368 px panel – första meningen säger vad sidan gör, resten är säljtext.

     ⚠️ DOM-operationen görs EN gång oavsett bredd, och CSS avgör vad som syns: på desktop
     visas hela texten och knappen är dold. Att göra om markupen vid varje resize hade kunnat
     dela texten mitt i sig själv en andra gång.
     ⚠️ Bara PLATT brödtext rörs (brytpunkten måste ligga direkt i .wubs-main-copy). Ligger
     meningen inuti ett <p> eller en länk lämnas allt orört – hellre ingen "Läs mer" än en
     sönderklippt text. */
  function forstaMeningsslut(text) {
    var re = /[.!?]+(?=\s|$)/g, m;
    while ((m = re.exec(text))) {
      var slut = m.index + m[0].length;
      var rest = text.slice(slut);
      /* Förkortning? Då följer en gemen bokstav ("t.ex. detta", "ca. 30"). Kräv versal,
         siffra eller textslut efter punkten. */
      if (!rest.trim() || /^\s+[A-ZÅÄÖ0-9]/.test(rest)) return slut;
    }
    return -1;
  }

  (function lasMer() {
    var copy = root.querySelector('.wubs-page-intro .wubs-main-copy');
    if (!copy || copy.dataset.lasmer) return;
    var slut = forstaMeningsslut(copy.textContent || '');
    if (slut < 0) return;

    var kvar = slut, gang = document.createTreeWalker(copy, NodeFilter.SHOW_TEXT), nod;
    var malNod = null, malPos = 0;
    while ((nod = gang.nextNode())) {
      if (kvar <= nod.nodeValue.length) { malNod = nod; malPos = kvar; break; }
      kvar -= nod.nodeValue.length;
    }
    if (!malNod || malNod.parentNode !== copy) return;
    if (malPos >= (copy.textContent || '').length) return;   // bara en mening – inget att fälla ut

    var rest = malNod.splitText(malPos);
    var wrap = document.createElement('span');
    wrap.className = 'wubs-intro-mer';
    var n = rest;
    while (n) { var nasta = n.nextSibling; wrap.appendChild(n); n = nasta; }
    copy.appendChild(wrap);

    var knapp = document.createElement('button');
    knapp.type = 'button';
    knapp.className = 'wubs-intro-lasmer';
    knapp.textContent = 'Läs mer';
    knapp.setAttribute('aria-expanded', 'false');
    knapp.addEventListener('click', function () {
      var oppen = copy.classList.toggle('is-open');
      knapp.textContent = oppen ? 'Visa mindre' : 'Läs mer';
      knapp.setAttribute('aria-expanded', oppen ? 'true' : 'false');
    });
    copy.appendChild(knapp);
    copy.dataset.lasmer = '1';
  })();

  lage();
  window.addEventListener('resize', lage);
  window.addEventListener('load', lage);
  setTimeout(lage, 400);
  setTimeout(lage, 1200);

  // Exponerad för verifiering (rAF och scroll-händelser beter sig annorlunda i förhandsgranskningen).
  window.WubsKonfigSteg = { lage: lage, matt: matt, numpad: numpad, tillToppen: tillToppen, visa: visa, speglaNasta: speglaNasta, placeraKnapp: placeraKnapp, oppna: oppna, stang: stang, tips: tips, sista: sista };
})();
